import { IOffer } from '../types/offer';

export function getOfferHasBestPlaceAnalytics(offer: IOffer) {
  return !!offer.bestPlaceAnalyticsAvailable;
}
